import {Injectable} from '@angular/core';
import {TimeSlotViewModel} from '@core/models';
import {PostgresBookingService} from '@core/services/postgres-booking.service';
import {
  bookLaterSlotsToTimeSlotView,
  calendarDateInIndia,
  DEFAULT_ADVANCE_BOOKING_DAYS,
  emptyTimeSlotView,
  normalizeMaxAdvanceDays,
} from '@shared/utils/book-later-slots.util';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

export interface TimeSlotListResult {
  view: TimeSlotViewModel;
  maxAdvanceDays: number;
}

@Injectable({
  providedIn: 'root'
})
export class CreateSlotService {
  constructor(
    private postgresBooking: PostgresBookingService,
  ) {
  }

  getTimeSlots(
    chargingDate: Date,
    chargerId: string,
    duration: number,
    connectorNo?: number,
  ): Observable<TimeSlotListResult> {
    if (connectorNo == null) {
      return of({
        view: emptyTimeSlotView,
        maxAdvanceDays: DEFAULT_ADVANCE_BOOKING_DAYS,
      });
    }

    const date = calendarDateInIndia(chargingDate);
    return this.postgresBooking.slots(chargerId, connectorNo, duration, date).pipe(
      map((response) => ({
        view: bookLaterSlotsToTimeSlotView(response.slots),
        maxAdvanceDays: normalizeMaxAdvanceDays(response.maxAdvanceDays),
      })),
      catchError(() => of({
        view: emptyTimeSlotView,
        maxAdvanceDays: DEFAULT_ADVANCE_BOOKING_DAYS,
      })),
    );
  }
}
